var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_coreJsData.js
// module id = 4019
// module chunks = 168707334958949